export default "__VITE_ASSET__dWjxC2aq__"